export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: '"Noto Serif JP", serif' }}>
              合同会社Nature
            </h3>
            <p className="text-gray-400 text-sm" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
              営業代行業務
            </p>
          </div>

          <div className="border-t border-gray-700 pt-8">
            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div>
                <h4 className="font-bold mb-3" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  会社情報
                </h4>
                <p className="text-sm text-gray-400" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  〒239-0831<br />
                  神奈川県横須賀市ハイランド三丁目27番24号<br />
                  設立：令和6年10月25日
                </p>
              </div>
              <div>
                <h4 className="font-bold mb-3" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  営業時間
                </h4>
                <p className="text-sm text-gray-400" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  平日 9:00 - 18:00<br />
                  土日祝日は休業
                </p>
              </div>
            </div>

            <div className="text-center pt-8 border-t border-gray-700">
              <p className="text-sm text-gray-400" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                &copy; 2024 合同会社Nature All Rights Reserved. 
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}